/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShipmentDto } from '../../models/shipment-dto';
import { ShipmentUpdateDto } from '../../models/shipment-update-dto';

export interface ShipmentControllerUpdate$Params {
  id: string;
      body: ShipmentUpdateDto
}

export function shipmentControllerUpdate(http: HttpClient, rootUrl: string, params: ShipmentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipmentDto>> {
  const rb = new RequestBuilder(rootUrl, shipmentControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShipmentDto>;
    })
  );
}

shipmentControllerUpdate.PATH = '/api/shipments/{id}';
